import { bl_fi_sales_contract_template_mail_merge_link_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesContractTemplateMailMergeLinkContainerModel extends BaseContainerModel {
    bl_fi_sales_contract_template_mail_merge_link: bl_fi_sales_contract_template_mail_merge_link_RowClass = new bl_fi_sales_contract_template_mail_merge_link_RowClass();
}